import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useProjectBreadcrumb } from '@/common/useProjectBreadcrumb'
import { PageHeader } from '@/components/PageHeader'
import { NewPresentationForm } from '@/components/presentation/NewPresentationForm'
import { getPresentationDefaultTemplate } from '@/api/documentAgent/documentAgent'
import { getProposal, getProposalSources } from '@/api/proposals/proposals'

const searchSchema = z.object({
  fromProposalId: z.coerce.number().int().positive().optional()
})

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/presentation-agent/')({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ fromProposalId: search.fromProposalId }),
  loader: async ({ params, deps }) => {
    const projectId = Number(params.projectId)
    const [templateResult, proposal, proposalSources] = await Promise.all([
      getPresentationDefaultTemplate(),
      deps.fromProposalId ? getProposal(projectId, deps.fromProposalId) : Promise.resolve(null),
      deps.fromProposalId ? getProposalSources(projectId, deps.fromProposalId) : Promise.resolve([])
    ])
    return { template: templateResult.template, proposal, proposalSources }
  },
  head: () => ({ meta: [{ title: 'Presentation Agent - Snowvault' }] }),
  component: PresentationAgentIndex
})

function PresentationAgentIndex() {
  const { orgSlug, projectId } = Route.useParams()
  const { template, proposal, proposalSources } = Route.useLoaderData()
  const { projectTitle, projectTo } = useProjectBreadcrumb()
  return (
    <>
      <PageHeader breadcrumbs={[{ label: projectTitle, to: projectTo }, { label: 'Presentation Agent' }]} />
      <div className="flex flex-1 flex-col items-center overflow-y-auto p-6">
        <NewPresentationForm
          projectId={Number(projectId)}
          orgSlug={orgSlug}
          defaultTemplate={template}
          {...(proposal ? { sourceProposal: proposal } : {})}
          sourceProposalSources={proposalSources}
        />
      </div>
    </>
  )
}
